import { render, staticRenderFns } from "./Cleave.vue?vue&type=template&id=4a588ff0&scoped=true&"
import script from "./Cleave.vue?vue&type=script&lang=js&"
export * from "./Cleave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a588ff0",
  null
  
)

export default component.exports